export enum Experiments {
  FULL_DEAL_CONTEXT_ENTRY_BLOCK = '8a2b442a-f52a-4e9c',
  SEA_OFFERS_LIMIT = 'cee740fa-8727-468a',
  DISABLE_AUTHORIZED_REFERALS = 'bd6ab866-1354-45dc',
  SPECIAL_PAGE_CLICKS = '859ba9d6-1415-434d',
}

export type AbTestingExperiments = Partial<Record<Experiments, boolean>>;

export const A_TEST_VALUE = '0';
export const B_TEST_VALUE = '1';
export const C_TEST_VALUE = '2';
export const D_TEST_VALUE = '3';
